import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import Input from "../components/input";
import Button from "../components/Button";

const SettingsPassword = () => {
  const formik = useFormik({
    initialValues: {
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    },
    validationSchema: Yup.object({
      oldPassword: Yup.string().required("L'ancien mot de passe est requis"),
      newPassword: Yup.string()
        .min(8, "Le nouveau mot de passe doit contenir au moins 8 caractères")
        .required("Le nouveau mot de passe est requis"),
      confirmPassword: Yup.string()
        .oneOf(
          [Yup.ref("newPassword"), null],
          "Les mots de passe ne correspondent pas"
        )
        .required("La confirmation est requise"),
    }),
    onSubmit: (values) => {
      console.log("Appel API pour mise à jour :", values);
    },
  });

  const isButtonDisabled =
    !formik.isValid || !formik.dirty || formik.isSubmitting;

  return (
    <div className="min-h-screen w-full flex items-center justify-center bg-slate-100 px-4 py-10 font-sans">
      <form
        className="bg-white shadow-2xl w-full max-w-[550px] flex flex-col gap-6 rounded-2xl py-12 transition-all"
        onSubmit={formik.handleSubmit}
      >
        <div className="text-2xl md:text-3xl font-extrabold text-[#111136] mx-auto mb-4 flex items-center gap-3">
          Sécurité 🔐
        </div>

        <div className="w-full flex flex-col items-start gap-1 px-6 md:px-12">
          <Input
            label="Ancien mot de passe"
            id="oldPassword"
            name="oldPassword"
            type="password"
            value={formik.values.oldPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.oldPassword ? formik.errors.oldPassword : ""}
            placeholder="Mot de passe actuel"
            className="w-full"
          />
        </div>

        <div className="border-t border-slate-100 w-4/5 mx-auto my-2"></div>

        <div className="w-full flex flex-col items-start gap-1 px-6 md:px-12">
          <Input
            type="password"
            label="Nouveau mot de passe"
            id="newPassword"
            name="newPassword"
            value={formik.values.newPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={formik.touched.newPassword ? formik.errors.newPassword : ""}
            placeholder="Nouveau mot de passe (8+ car.)"
            className="w-full"
          />
        </div>

        <div className="w-full flex flex-col items-start gap-1 px-6 md:px-12">
          <Input
            label="Confirmer le mot de passe"
            id="confirmPassword"
            name="confirmPassword"
            type="password"
            value={formik.values.confirmPassword}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            error={
              formik.touched.confirmPassword
                ? formik.errors.confirmPassword
                : ""
            }
            placeholder="Répétez le nouveau mot de passe"
            className="w-full"
          />
        </div>

        <div className="px-6 md:px-12 mt-4">
          <Button
            variant="primary"
            type="submit"
            disabled={isButtonDisabled}
            className={`w-full h-14 md:h-16 rounded-xl font-bold text-lg transition-all shadow-md flex items-center justify-center gap-2
              ${
                isButtonDisabled
                  ? "bg-slate-300 cursor-not-allowed opacity-70"
                  : "hover:bg-indigo-600 hover:scale-[1.01] active:scale-95 bg-indigo-500"
              }`}
          >
            {formik.isSubmitting ? "Chargement..." : "Mettre à jour 💾"}
          </Button>
        </div>

        <div className="mx-auto mt-2">
          <p className="text-[10px] text-slate-400 font-bold uppercase tracking-widest text-center px-4">
            Assurez-vous que les deux mots de passe sont identiques.
          </p>
        </div>
      </form>
    </div>
  );
};

export default SettingsPassword;
